import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import { projectApi } from '@api/project';
import CheckBox from '@ui/CheckBox';
import { Card, List, Pagination } from 'antd';
import Meta from 'antd/lib/card/Meta';
import React, { useEffect, useState } from 'react';
import { useRedux } from 'use-redux';
import styles from './styles.module.scss';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n';

const Projects = () => {
  const [projects, setProjects] = useState<any[]>([]);
  const [page, setPageNumber] = useState(1);
  const [total, setTotal] = useState(0);
  const [onlyMy, setOnlyMy] = useState(false);
  const [{ auth }] = useRedux();

  useEffect(() => {
    projectApi.getPublicProjects({ page, onlyMy }).then(result => {
      setProjects(result.items || []);
      setTotal(result.total || 0);
    });
  }, [page, onlyMy]);

  return (
    <div className="container">
      <div className={styles.header}>
        <h1>{I18n.t('nav.projects')}</h1>
        {auth.user && (
          <div>
            {I18n.t('gui.projects.onlyMy')}:{' '}
            <CheckBox
              value={onlyMy}
              onChange={e => {
                setPageNumber(1);
                setOnlyMy(e.target.checked);
              }}
            />
          </div>
        )}
      </div>
      <List
        grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 3, xl: 4, xxl: 4 }}
        dataSource={projects}
        renderItem={x => {
          const isOwner = x.userID === auth.user._id;
          const actions = [
            <Link to={`/project/shared/${x._id}`} target="_blank">
              <EyeOutlined key="view" translate={'1'} />
              {' ' + I18n.t('gui.projects.openButton')}
            </Link>,
          ];
          if (isOwner) {
            actions.push(
              <Link to={`/i/projects/${x._id}`}>
                <EditOutlined key="edit" translate={'1'} />
                {' ' + I18n.t('gui.projects.changeButton')}
              </Link>
            );
          }

          return (
            <List.Item>
              <Card
                cover={
                  <img
                    alt="Project preview"
                    src={
                      (x.files || []).length
                        ? x.files[0]
                        : '/images/no_image.jpeg'
                    }
                  />
                }
                actions={actions}
              >
                <Meta
                  title={x.name}
                  description={
                    <>
                      <b>{x.lang}</b> {x.description}
                    </>
                  }
                />
              </Card>
            </List.Item>
          );
        }}
      />

      <div className={styles.footer}>
        <Pagination
          current={page}
          onChange={setPageNumber}
          total={total}
          pageSize={12}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default Projects;
